import axios from 'axios';

export default function createAxiosApi(baseURL: string) {
    const api = axios.create({
        baseURL,
        withCredentials: true,
    });

    api.defaults.headers.common.Accept = 'application/json';
    api.defaults.headers.post['Content-Type'] = 'application/json';
    api.defaults.headers.put['Content-Type'] = 'application/json';

    api.interceptors.response.use(
        response => response.data, // return data object
        error => Promise.reject(error),
    );
    return api;
}
